var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeather13D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "56px",
    viewBox: "0 0 58 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\xA0icon-13d") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-icon-13d",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(25.000000, 44.000000)",
    stroke: "#0A6EAC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,0 L5.5,10.5769231",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,0.5 L5,10.5",
    id: "Line-Copy",
    transform: "translate(5.000000, 5.500000) rotate(90.000000) translate(-5.000000, -5.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30357143,0.196428571 L5.69642857,10.8035714",
    id: "Line-Copy-2",
    transform: "translate(5.500000, 5.500000) rotate(45.000000) translate(-5.500000, -5.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30357143,0.196428571 L5.69642857,10.8035714",
    id: "Line-Copy-3",
    transform: "translate(5.500000, 5.500000) scale(-1, 1) rotate(45.000000) translate(-5.500000, -5.500000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(7.000000, 34.000000)",
    stroke: "#0A6EAC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,0 L5.5,10.5769231",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,0.5 L5,10.5",
    id: "Line-Copy",
    transform: "translate(5.000000, 5.500000) rotate(90.000000) translate(-5.000000, -5.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30357143,0.196428571 L5.69642857,10.8035714",
    id: "Line-Copy-2",
    transform: "translate(5.500000, 5.500000) rotate(45.000000) translate(-5.500000, -5.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30357143,0.196428571 L5.69642857,10.8035714",
    id: "Line-Copy-3",
    transform: "translate(5.500000, 5.500000) scale(-1, 1) rotate(45.000000) translate(-5.500000, -5.500000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(43.000000, 34.000000)",
    stroke: "#0A6EAC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,0 L5.5,10.5769231",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,0.5 L5,10.5",
    id: "Line-Copy",
    transform: "translate(5.000000, 5.500000) rotate(90.000000) translate(-5.000000, -5.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30357143,0.196428571 L5.69642857,10.8035714",
    id: "Line-Copy-2",
    transform: "translate(5.500000, 5.500000) rotate(45.000000) translate(-5.500000, -5.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30357143,0.196428571 L5.69642857,10.8035714",
    id: "Line-Copy-3",
    transform: "translate(5.500000, 5.500000) scale(-1, 1) rotate(45.000000) translate(-5.500000, -5.500000) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.5957673,30.7866961 C40.9460379,32.1682664 38.8201499,33 36.5,33 C34.2383018,33 32.1612006,32.2096463 30.52982,30.8900625 C28.7920918,32.8006439 26.2861082,34 23.5,34 C20.2213734,34 17.3306641,32.3391282 15.6233319,29.8128443 C14.2406266,30.571195 12.6680051,31 11,31 C5.4771525,31 1,26.2989899 1,20.5 C1,15.3123293 4.58296017,11.0033461 9.2922561,10.152506 C10.3372604,6.0411421 14.0634818,3 18.5,3 C20.4869426,3 22.3314144,3.60999017 23.8563644,4.65291957 C26.5050218,1.79138371 30.2933109,0 34.5,0 C41.3213409,0 47.0425355,4.71028611 48.5884592,11.0557337 C53.8759998,11.6003041 58,16.0685461 58,21.5 C58,27.2989899 53.2989899,32 47.5,32 C45.7285644,32 44.0595855,31.5613307 42.5957673,30.7866961 Z",
    id: "Combined-Shape-Copy-3",
    stroke: "#0A6EAC",
    fill: "#59A5D8",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeather13D);
export default __webpack_public_path__ + "static/media/icon-weather-13d.87478ff0cf757e5e28309cfbf0c78c78.svg";
export { ForwardRef as ReactComponent };